import React from "react";
import { Box } from "@mui/material";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { Icon, IconColor } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useStyles = makeStyles()((theme, _params, classes) => ({
  treeViewItemSelectOptionContent: {
    "& .MuiTreeItem-content": {
      padding: 0
    }
  },
  treeViewItemSelectOptionGroup: {
    "& .MuiTreeItem-group": {
      padding: theme.spacing(0.5, 0)
    }
  },
  treeViewItemSelectOptionLabel: {
    "& .MuiTreeItem-content .MuiTreeItem-label": {
      paddingLeft: 0
    }
  },
  treeViewItemSelectOptionIcon: {
    "& .MuiTreeItem-content .MuiTreeItem-iconContainer": {
      display: "none"
    }
  },
  treeViewItemSelectOption: {
    display: "flex",
    justifyContent: "space-between",
    borderRadius: 0,
    padding: theme.spacing(1.5, 2),
    "&:hover": {
      background: theme.palette.primary.light
    }
  },
  treeViewItemSelectOptionSelected: {
    background: theme.palette.primary.light,
    [`& .${classes.treeViewItemSelectOptionIcon}`]: {
      display: "block"
    }
  }
}));
function TreeViewItemSelectOption({ label, itemId, onClick, selected }) {
  const { classes, cx } = useStyles();
  function handleClick() {
    onClick(label);
  }
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(
        classes.treeViewItemSelectOptionIcon,
        classes.treeViewItemSelectOptionContent,
        classes.treeViewItemSelectOptionGroup,
        classes.treeViewItemSelectOptionLabel
      )
    },
    /* @__PURE__ */ React.createElement(
      TreeItem,
      {
        itemId,
        onClick: handleClick,
        label: /* @__PURE__ */ React.createElement(
          Box,
          {
            className: cx(
              {
                [classes.treeViewItemSelectOptionSelected]: selected
              },
              classes.treeViewItemSelectOption
            )
          },
          /* @__PURE__ */ React.createElement(LocalizedText, { label }),
          selected ? /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.Confirm, color: IconColor.Primary, className: classes.treeViewItemSelectOptionIcon }) : null
        )
      }
    )
  );
}
export {
  TreeViewItemSelectOption
};
//# sourceMappingURL=TreeViewItemSelectOption.js.map
